export default {
    data() {
      return {
      };
    },
    computed: {
    },
    methods: {

      handleFocusKeyboard( inst, scroll ){
        // console.log(" -- FOCUS");

        inst.$bar.hide();
        if( typeof scroll != 'undefined' ){
          this.scrollTo( scroll );
        }
      },
      handleBlurKeyboard( inst ){
        // console.log(" -- BLUR");

        inst.$bar.show();
      },

      scrollTo( scroll ){
        scroll.offset = typeof scroll.offset == 'undefined' ? 0 : scroll.offset;

        // console.log("container");
        // console.log(scroll.container);
        // console.log("target");
        // console.log(scroll.target.offsetTop);

        this.doScroll(scroll.container, scroll.target.offsetTop + scroll.offset, 200);
      },
      easeInOutQuad(t, b, c, d) {
        t /= d/2;
        if (t < 1) return c/2*t*t + b;
        t--;
        return -c/2 * (t*(t-2) - 1) + b;
      },
      doScroll(container, target, duration) {
        // console.log("container");
        // console.log(container);
        // console.log("target");
        // console.log(target);

        var self = this;
        var start = container.scrollTop,
            change = target - start,
            currentTime = 0,
            increment = 20;

        var animateScroll = function(){
            currentTime += increment;
            var val = self.easeInOutQuad(currentTime, start, change, duration);
            container.scrollTop = val;
            if(currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
        };
        animateScroll();
      },

      redirectPath(firstResult){
        var visible = [];
        var tools = this.$store.getters['getTools'];
        var result = firstResult;

        if( localStorage.config ) {
          var config = JSON.parse(localStorage.config);
          if( config.tools ) {
            visible = config.tools;
          }
        }
        if ( visible.length == 1 ) {
          result = tools[visible[0]].href;
        }

        return result;
      },
      formatEventName( name, edition ){
        return name + "'" + edition.substring(2);
      },
      formatEventUrl( name, edition ){
            return ( name.replace( / /g, '' ) + edition.substring(2) ).toLowerCase();
      },
    }
  };
